import {
    CONTROL_PANEL_SIDEBAR_OPEN_UPDATE,
    CONTROL_PANEL_SIDEBAR_CLOSE,
    CONTROL_PANEL_SIDEBAR_OPEN,
} from "../action-types/controlPanelSidebar"

export const controlPanelSidebarOpenComponent = (component) => ({ type: CONTROL_PANEL_SIDEBAR_OPEN_UPDATE, payload: component })
export const controlPanelSidebarClose = () => ({ type: CONTROL_PANEL_SIDEBAR_CLOSE })
export const controlPanelSidebarOpen = () => ({ type: CONTROL_PANEL_SIDEBAR_OPEN })
